import React, { useEffect, useState } from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import HeaderSubcategory from "../../molecules/header-subcategory/header-subcategory"
import ProductsListSection from "../../molecules/products-list-section/products-list-section"
import Towelstype from "../../molecules/towels-type/towels-type"
import ProductService from "../../../shared/services/product"
import "./subcategory-content.scss"

const SubcategoryContent = props => {
  const { context, mobile, setModalActive } = props
  const params = context.params
  const [listAverage, setlistAverage] = useState({})

  useEffect(() => {
    ProductService.listAverage()
      .then(res => {
        if (res.status === 200) {
          const objList = res.data.reduce(
            (acc, currentValue) => ({
              ...acc,
              [currentValue.productId]: currentValue.score,
            }),
            {}
          )
          setlistAverage(objList)
        } else {
          console.log(res)
        }
      })
      .catch(e => console.log(e))
  }, [])

  return (
    <div className="f-subcategory-products">
      <div className="f-breadcrum-position">
        <Breadcrumb />
      </div>
      <HeaderSubcategory img={params.bannerSubcategoria} />
      <ProductsListSection
        title={params.titulo}
        infoBannerInterno={
          params.tieneBannerInterno &
          {
            bannerInternoRedireccion: params.bannerInternoRedireccion,
            bannerInternoImagen: params.bannerInternoImagen,
          }
        }
        ctaSubcategoria={params.ctaSubcategoria}
        listAverage={listAverage}
        mobile={mobile}
        filter={params.filtro}
        setModalActive={setModalActive}
        currentCategory={context.paternSlug}
        currentSubcategory={context.params.slug}
        products={params.productos}
      />
      {params.tiposDeToallas && !mobile && (
        <Towelstype
          categoria={params.categoria}
          subcategoria={params.slug}
          Towelstype={params.tiposDeToallas}
        />
      )}
    </div>
  )
}

export default SubcategoryContent
